import cn from "classnames";
import React from "react";
import Template from "./template";

export default class Flags extends Template {
    setValue = (newValue) => {
        const { inputProps, onChange, value, disabled } = this.props;
        if (onChange) {
            if (inputProps.disabled || disabled) {
                return onChange({ name: inputProps.name, value });
            }
            this.validate(newValue);
            return onChange({ name: inputProps.name, value: newValue });
        }
    };

    renderFlagItem = (option, i) => {
        const { disabled, value } = this.props;
        const optionDisabled = disabled || option.disabled;
        const checked = (value & option.intValue) === option.intValue;
        const checkboxCname = cn("checkbox checkbox--inline mr-2", {
            "checkbox--checked": checked,
            "checkbox--disabled": optionDisabled,
        });
        const { index } = this.props;
        return (
            <div key={option.intValue} name={`flags_${index}_${i}`}>
                <span
                    className={checkboxCname}
                    onClick={!optionDisabled ? this.toggleCheckbox.bind(this, option.intValue, !checked) : undefined}
                />

                <span
                    className="col-form-label-sm checkbox__text"
                    onClick={!optionDisabled ? this.toggleCheckbox.bind(this, option.intValue, !checked) : undefined}
                >
                    {option.label}
                </span>
            </div>
        );
    };

    toggleCheckbox = (intValue, checked) => {
        const { value } = this.props;
        const flagValue = checked ? value + intValue : value - intValue;
        this.setValue(flagValue);
    };

    renderField = () => {
        const { flags } = this.props;
        return <div className="my-1">{flags.filter((f) => f.intValue !== 0).map(this.renderFlagItem)}</div>;
    };
}
